var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"inputfiles",staticClass:"inputfile",attrs:{"id":"file","type":"file","name":"file","multiple":"","disabled":_vm.disabled},on:{"change":_vm.inputLoadFiles}})}
var staticRenderFns = []

export { render, staticRenderFns }